import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { getEarliestEffectiveDate, getEarliestEffectiveDateMessage } from '../shared/utils';

export function effectiveDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as Date | null;

    if (!value) {
      return null;
    }

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const selected = new Date(value.getFullYear(), value.getMonth(), value.getDate());

    const maxFuture = new Date(today);
    maxFuture.setDate(maxFuture.getDate() + 60);

    const earliest = getEarliestEffectiveDate(today);
    const earliestMessage = getEarliestEffectiveDateMessage(today);

    const errors: ValidationErrors & any = {};

    if (selected < today) {
      errors.effectiveDateInPast = true;
    } else if (selected < earliest) {
      errors.effectiveDateTooEarly = { message: earliestMessage };
    }

    if (selected > maxFuture) {
      errors.effectiveDateTooFarInFuture = true;
    }

    return Object.keys(errors).length ? errors : null;
  };
}
